import { makeStyles, Text } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { LoaderThumbnailIcon } from '@utils-global';

const useStyles = makeStyles({
  wrapper: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(154.73deg, #08142E 0%, #1F3460 109.09%)',
    gap: '24px',
  },
  icon: {
    width: '60px',
    height: '60px',
  },
  text: {
    color: '#ffffff',
    fontFamily: "'Quicksand', sans-serif",
    textAlign: 'center',
  },
});

export const AppLoader = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <LoaderThumbnailIcon className={styles.icon} aria-hidden="true" />
      <Text weight="semibold" size={400} className={styles.text}>
        {t('appLoader.title')}
      </Text>
    </div>
  );
};
